export const AI_CHAT_ENABLED = process.env.NEXT_PUBLIC_AI_CHAT_ENABLED === 'true';

// Pages where the AI chat popup is NOT shown
export const PAGES_WITHOUT_AI_CHAT = ['/privacy-policy', '/thanks', '/404'];

export const AI_CHAT_Z_INDEX = 1200;
export const AI_CHAT_AGENT_NAME = 'homepage_chat_agent';

// What a visitor can pick in the chat's "what would you like to build" step. Keys are what the
// agent receives and what lands in the lead email; labels live in common.json (aiChat.lead.services).
export const AI_CHAT_SERVICE_KEYS = ['aiAgent', 'automation', 'aiProduct', 'aiAudit', 'other'] as const;
export type AiChatServiceKey = (typeof AI_CHAT_SERVICE_KEYS)[number];

// Voice mode inside the chat (ElevenLabs agent). Off unless the env flag is set; the API key and
// agent id are server-only (`/api/ai-voice/session`).
export const AI_VOICE_ENABLED = process.env.NEXT_PUBLIC_AI_VOICE_ENABLED === 'true';

// Client-side cap on one voice conversation. The agent's own max duration (ElevenLabs dashboard)
// is the real limit — this only makes sure a forgotten tab can't keep a paid session open.
export const AI_VOICE_MAX_SECONDS = 300;
